// @flow
import React, { useState, useEffect } from 'react'
import classnames from 'classnames'
import styles from './curve.module.scss'

interface Props {
  className?: string
  children: React.ReactNode
  notransition?: boolean
}

const Curve = ({ className = '', children, notransition = false }: Props) => {
  const [ isActive, setActive ] = useState(notransition)
  useEffect(() => setActive(true), [ children ])
  return (
    <div
      className={classnames(styles.container, className, {
        [styles.active]: isActive,
      })}
    >
      <div className={styles.inner}>{children}</div>
      <div className={styles.curve} />
    </div>
  )
}

export default Curve
